import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  BarsIcon,
  LockIcon,
  CalendarIcon
} from '../../../../../components/ui/icons';
import TextLink from '../../../../../components/ui/TextLink';
import styles from './Features.module.css';

const CARDS = [
  {
    Icon: BarsIcon,
    titleKey: 'FEATURE_QUALITY_TITLE',
    body1Key: 'FEATURE_QUALITY_BODY_1',
    emphasisKey: 'SEBRAE',
    body2Key: 'FEATURE_QUALITY_BODY_2'
  },
  {
    Icon: LockIcon,
    titleKey: 'FEATURE_SECURITY_TITLE',
    body1Key: 'FEATURE_SECURITY_BODY_1',
    emphasisKey: 'SEBRAE',
    body2Key: 'FEATURE_SECURITY_BODY_2'
  },
  {
    Icon: CalendarIcon,
    titleKey: 'FEATURE_PAYMENT_TITLE',
    body1Key: 'FEATURE_PAYMENT_BODY_1',
    emphasisKey: 'FEATURE_PAYMENT_BODY_2',
    body2Key: null
  }
];

function Features() {
  const { t } = useTranslation('home');
  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {CARDS.map(
            ({ Icon, titleKey, body1Key, emphasisKey, body2Key }, i) => (
              <div key={i} className={styles.cell}>
                <div className={styles.content}>
                  <Icon size={21} className={styles.icon} />
                  <h3 className={styles.title}>{t(titleKey)}</h3>
                  <p className={styles.body}>
                    {t(body1Key)}
                    <span className={styles.emphasis}>{t(emphasisKey)}</span>
                    {body2Key && t(body2Key)}
                  </p>
                  <TextLink as={Link} to='/faq' className={styles.link}>
                    {t('KNOW_MORE')}
                  </TextLink>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}

export default Features;
